export default __webpack_public_path__ + "static/media/Shipment.d3fcbac2.svg";